import Vue from 'vue'
import Vuex from 'vuex'
import user from "./user.js"
import { getCartList } from "@/api/cart.js"
Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    cartList: []
  },

  mutations: {
    setCart(state, value) {
      state.cartList = value
    }
  },
  actions: {
    async getCartAciton(context) {
      let { data: { list } } = await getCartList()
      list.forEach(item => {
        item.isChecked = true
      });

      context.commit('setCart', list)

    }
  },
  getters: {
    // 所有的商品
    cartTotal(state) {
      return state.cartList.reduce((sum, item,index) => 
        sum += item.goods_num
      ,0)
    },
    // 选中的商品
    selectCart(state) {
      return state.cartList.filter(item => item.isChecked)
    },

    // 选中商品的总数
    selectCartTotal(state, getters) {
      return getters.selectCart.reduce((sum, item,index) => 
        sum + item.goods_num
      ,0)
    },
    // 选中商品的总价
    selectCartTotalPrice(state, getters) {
      return getters.selectCart.reduce((sum, item,index) => 
        sum + item.goods_num * item.goods.goods_price_min
      ,0)
    }


  },
  modules: {
    user
  }
})
